module.exports = __webpack_public_path__ + "img/rectangle-small.f63f9e3f.svg";